export default function WatchIcon({ size = 24, color = '#272937' }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M11.7178 20.208C16.2741 20.208 19.9678 16.5144 19.9678 11.958C19.9678 7.40166 16.2741 3.70801 11.7178 3.70801C7.16142 3.70801 3.46777 7.40166 3.46777 11.958C3.46777 16.5144 7.16142 20.208 11.7178 20.208Z" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M11.1677 7.00815V11.9581L14.4677 13.6081" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}
